"use client";

import {
  colors,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import type { CreatorStatus } from "./coworld-records";

export function CoworldStatus({ label, tone }: CreatorStatus) {
  return (
    <span {...stylex.props(styles.status, tone === "danger" && styles.danger)}>
      <span aria-hidden="true">{tone === "danger" ? "!" : "·"}</span>
      {label}
    </span>
  );
}
const styles = stylex.create({
  status: {
    display: "inline-flex",
    alignItems: "center",
    gap: spacing.space6,
    fontSize: fontSizes.small,
    whiteSpace: "nowrap",
  },
  danger: { color: colors.danger },
});
